import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as moment from "moment";

import {
  Badge,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import { map } from "lodash";

//Import Image
import images from "assets/images";
import companies from "assets/images/companies";

import {
  getProjects,
  updateProject,
  deleteProject,
} from "../../store/projects/actions";

class LabsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      project: "",
      deleteModal: false,
      modal: false,
      subscribemodal: false,
    };

    this.handleProjectClick = this.handleProjectClick.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleProjectClicks = this.handleProjectClicks.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }

  componentDidMount() {
    const { projects, onGetProjects } = this.props;
    onGetProjects();
    this.setState({ projects });
  }

  handleProjectClicks = arg => {
    this.setState({ selectedProject: arg });
    this.toggle();
  };

  //Delete project list
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };

  onClickDelete = project => {
    this.setState({ project: project });
    this.setState({ deleteModal: true });
  };

  handleDeleteProject = () => {
    const { onDeleteProject } = this.props;
    const { project } = this.state;
    if (project.id !== undefined) {
      onDeleteProject(project);
      this.setState({ deleteModal: false });
    }
  };

  handleProjectClick = arg => {
    const project = arg;

    this.setState({
      project: {
        id: project.id,
        img: project.img,
        name: project.name,
        description: project.description,
        status: project.status,
        color: project.color,
        dueDate: project.dueDate,
        team: project.team,
      },
      isEdit: true,
    });

    this.toggle();
  };

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  render() {
    const { projects } = this.props;
    const { isEdit, deleteModal } = this.state;
    const { onAddNewProject, onUpdateProject } = this.props;
    const project = this.state.project;

    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteProject}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Dashboard" breadcrumbItem="Labs List" />
            <Row>
              <Col lg="12">
                <div className="">
                  <div className="table-responsive">
                    <Table className="project-list-table table-nowrap align-middle table-borderless">
                      <thead>
                        <tr>
                          <th scope="col" style={{ width: "100px" }}>
                            Logo
                          </th>
                          <th scope="col">Lab</th>
                          <th scope="col">Creation Date</th>
                          <th scope="col">Inspection</th>
                          <th scope="col">Contact Number</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(projects, (project, index) => (
                          <tr key={index}>
                            <td>
                              <img
                                src={companies[project.img]}
                                alt=""
                                className="avatar-sm"
                              />
                            </td>
                            <td>
                              <h5 className="text-truncate font-size-14">
                                <Link
                                  to={`#`}
                                  className="text-dark"
                                >
                                  {project.name}
                                </Link>
                              </h5>
                              <p className="text-muted mb-0">
                                {project.description}
                              </p>
                            </td>

                            <td>{this.handleValidDate(project.dueDate)}</td>
                            <td>
                              <Badge
                                color={project.color}
                                className={"bg-" + project.color}
                              >
                                {project.status}
                              </Badge>
                            </td>
                            <td>
                              <td>0311-5129293</td>
                            </td>
                            <td>
                              <Link
                                to={`/lab-overview/${project.id}`}
                                className="btn btn-primary btn-sm btn-rounded"
                              >
                                View Details
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs="12">
                <div className="text-center my-3">
                  <Link
                    to="#"
                    onClick={() => this.setState({ subscribemodal: true })}
                    className="text-success"
                  >
                    <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                    Load more
                  </Link>
                </div>
              </Col>
            </Row>
            <Modal
              isOpen={this.state.subscribemodal}
              role="dialog"
              autoFocus={true}
              data-toggle="modal"
              centered
              toggle={this.togglesubscribemodal}
            >
              <div className="modal-content">
                <div className="modal-header border-bottom-0">
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => this.setState({ subscribemodal: false })}
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="text-center mb-4">
                    <div className="avatar-md mx-auto mb-4">
                      <div className="avatar-title bg-light  rounded-circle text-primary h1">
                        <i className="dripicons-box"></i>
                      </div>
                    </div>

                    <div className="row justify-content-center">
                      <div className="col-xl-10">
                        <h4 className="text-primary">Comming Soon !</h4>
                        <p className="text-muted font-size-14 mb-4">
                          More Labs will be available when the application will
                          go live
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

LabsList.propTypes = {
  projects: PropTypes.array,
  className: PropTypes.any,
  onGetProjects: PropTypes.func,
  onDeleteProject: PropTypes.func,
  onUpdateProject: PropTypes.func,
  onAddNewProject: PropTypes.func,
};

const mapStateToProps = ({ projects }) => ({
  projects: projects.projects,
});

const mapDispatchToProps = dispatch => ({
  onGetProjects: () => dispatch(getProjects()),
  onUpdateProject: project => dispatch(updateProject(project)),
  onDeleteProject: project => dispatch(deleteProject(project)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LabsList));
